import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=683c753c&"
import script from "./AppLayout.vue?vue&type=script&lang=js&"
export * from "./AppLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QDrawer,QScrollArea,QPageContainer,QPage} from 'quasar'
component.options.components = Object.assign({QLayout,QDrawer,QScrollArea,QPageContainer,QPage}, component.options.components || {})
